export const adminScope = 'dice-agent_admin';
export const superuserScope = 'dice-agent_superuser';
export const agentScope = 'dice-agent_user';

export const validDiceScopes: string[] = [agentScope, superuserScope, adminScope];
